import { forwardRef } from 'react';

import { IconProps } from './icons.types';

export const LogsIcon = forwardRef<SVGSVGElement, IconProps>(function LogsIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75761 1.81388C3.20528 0.351272 5.59245 0 9 0C12.4075 0 14.7947 0.351272 16.2424 1.81388C16.9613 2.54019 17.394 3.48705 17.6515 4.65774C17.9084 5.82584 18 7.26017 18 9C18 10.7398 17.9084 12.1742 17.6515 13.3423C17.394 14.5129 16.9613 15.4598 16.2424 16.1861C14.7947 17.6487 12.4075 18 9 18C5.59245 18 3.20528 17.6487 1.75761 16.1861C1.03873 15.4598 0.606037 14.5129 0.348518 13.3423C0.0915693 12.1742 0 10.7398 0 9C0 7.26017 0.0915693 5.82584 0.348518 4.65774C0.606037 3.48705 1.03873 2.54019 1.75761 1.81388ZM1.70811 4.88733C1.47633 5.941 1.38462 7.28384 1.38462 9C1.38462 10.7162 1.47633 12.059 1.70811 13.1127C1.93932 14.1637 2.30079 14.8832 2.80366 15.3913C3.79949 16.3974 5.56617 16.7868 9 16.7868C12.4338 16.7868 14.2005 16.3974 15.1963 15.3913C15.6992 14.8832 16.0607 14.1637 16.2919 13.1127C16.5237 12.059 16.6154 10.7162 16.6154 9C16.6154 7.28384 16.5237 5.941 16.2919 4.88733C16.0607 3.83625 15.6992 3.11676 15.1963 2.60871C14.2005 1.60261 12.4338 1.21316 9 1.21316C5.56617 1.21316 3.79949 1.60261 2.80366 2.60871C2.30079 3.11676 1.93932 3.83625 1.70811 4.88733ZM6.92308 5.50274C6.92308 5.16774 7.23303 4.89616 7.61538 4.89616H10.3846C10.767 4.89616 11.0769 5.16774 11.0769 5.50274C11.0769 5.83775 10.767 6.10932 10.3846 6.10932H7.61538C7.23303 6.10932 6.92308 5.83775 6.92308 5.50274ZM4.84615 9C4.84615 8.665 5.15611 8.39342 5.53846 8.39342H12.4615C12.8439 8.39342 13.1538 8.665 13.1538 9C13.1538 9.335 12.8439 9.60658 12.4615 9.60658H5.53846C5.15611 9.60658 4.84615 9.335 4.84615 9ZM6.92308 12.4973C6.92308 12.1623 7.23303 11.8907 7.61538 11.8907H10.3846C10.767 11.8907 11.0769 12.1623 11.0769 12.4973C11.0769 12.8323 10.767 13.1038 10.3846 13.1038H7.61538C7.23303 13.1038 6.92308 12.8323 6.92308 12.4973Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
